
export const VIDEO_MAP = Object.freeze({});

export function resolveVidPath(v) {
    if (!v) return null;
    if (v.includes("/")) return v;

    // 예: Static-F-0095, MS-Neck-0052
    const m3 = v.match(/^([A-Za-z]+)-([A-Za-z]+)-(\d+)/i);
    if (m3) {
        const [, a, b] = m3;
        const dir = b.length > 1 ? `${a}-${b}` : a; // 'S'면 Static, 'Neck'이면 MS-Neck
        return `${dir}/${v}`;
    }

    // 예: FR-0001, CB-0016, Dumbbell-0048
    const m2 = v.match(/^([A-Za-z]+)-(\d+)/i);
    if (m2) return `${m2[1]}/${v}`;

    return null;
}